import { Stack } from '@mui/material'
import LABEL_COLORS from '../TopicLabel/colors'
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined'

const TopicLabelPicker = ({
  selectedColor,
  onSelectColor,
}: {
  selectedColor: string
  onSelectColor: (color: string) => void
}) => {
  return (
    <Stack justifyContent="space-between" flexWrap="wrap" gap="9px" direction="row" px="14px" pt="14px" pb="14px">
      {LABEL_COLORS.map((color) => (
        <Stack
          borderRadius="4px"
          key={color}
          justifyContent="center"
          alignItems="center"
          onClick={() => onSelectColor(color)}
          sx={{
            backgroundColor: color,
            width: '20px',
            height: '20px',
            cursor: 'pointer',
            '&:hover': {
              boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.12)',
            },
          }}>
          {selectedColor === color && (
            <CheckOutlinedIcon
              sx={{
                color: '#fff',
                height: '18px',
                width: '18px',
              }}
            />
          )}
        </Stack>
      ))}
    </Stack>
  )
}

export default TopicLabelPicker
